module.exports = "./assets/images/avatar-1.svg";